import React from 'react'
import { useDispatch, useSelector } from "react-redux"
import { FlexContainer, Label } from "heliocor-ui"
import { useTranslation } from "react-i18next"
import Checkbox from "@material-ui/core/Checkbox"

import { SET_CURRENT_OWNER_CATEGORY_REQUEST } from "../../store/cafe/actionTypes"

const SendDocumentRequest = ({ documentCategory, documents, requestEmail }) => {

    const { t } = useTranslation()
    const dispatch = useDispatch()

    const categoryId = documentCategory?.code || documentCategory?.name
    const currentOwnerDocs = useSelector(store => store.currentOwnerDocs) || []
    
    const categoryDocs = currentOwnerDocs.filter(doc => doc.category === categoryId)
    const isCategoryRequested = categoryDocs.reduce((res, doc) => (res && !!doc?.request), !!categoryDocs.length);

    const handleRequestChange = (e) => {
        e && e.stopPropagation()
        dispatch({
            type: SET_CURRENT_OWNER_CATEGORY_REQUEST,
            documentCategory: categoryId,
            documents: e?.target?.checked ? documents : []
        })
    }

    React.useEffect(() => {
        if(!requestEmail && isCategoryRequested) {
            handleRequestChange()
        }
    }, [requestEmail, isCategoryRequested])

    return (
        <FlexContainer alignItems="center">
            {!!requestEmail && (
                <Checkbox
                    data-cy="send-request-checkbox"
                    checked={isCategoryRequested}
                    onClick={handleRequestChange}
                />
            )}
            <Label
                disabled={!requestEmail}
                customLabel={t('sendRequest.label')}
                tooltip={!!requestEmail ? t('sendRequest.tooltip') : t('sendRequest.tooltip_email')}
            />
        </FlexContainer>
    )
}

export { SendDocumentRequest }